import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import { setSessionStore, getSessionStore, removeSessionStore,setLocalStore,getLocalStore,removeLocalStore } from '@/libs/storage'
import { getRequest, postRequest, putRequest, deleteRequest, uploadFileRequest } from '@/libs/axios'

// 挂载全局使用的方法
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.setSessionStore = setSessionStore;
Vue.prototype.getSessionStore = getSessionStore;
Vue.prototype.removeSessionStore = removeSessionStore;
Vue.prototype.setLocalStore = setLocalStore;
Vue.prototype.getLocalStore = getLocalStore;
Vue.prototype.removeLocalStore = removeLocalStore;

Vue.config.productionTip = false

Vue.directive('has', {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  }
});
//权限检查方法
Vue.prototype.$_has = function(value) {
  let isExist=false;
  let userinfo= JSON.parse(localStorage.getItem("userinfo"));
  if(userinfo != undefined && userinfo!= null){
    let pFlag = userinfo.pflag;
    if(pFlag != undefined && pFlag != null){
      var i=pFlag.findIndex((v)=>v==value);
      if( i >= 0){
        isExist = true;
      }
    }
  }
  return isExist;
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
